import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.57733 3.57733C3.90277 3.25189 4.4304 3.25189 4.75584 3.57733L10.5892 9.41066C10.9146 9.7361 10.9146 10.2637 10.5892 10.5892L4.75584 16.4225C4.4304 16.7479 3.90277 16.7479 3.57733 16.4225C3.25189 16.0971 3.25189 15.5694 3.57733 15.244L8.82141 9.99992L3.57733 4.75584C3.25189 4.4304 3.25189 3.90277 3.57733 3.57733ZM10.244 3.57733C10.5694 3.25189 11.0971 3.25189 11.4225 3.57733L17.2558 9.41066C17.5813 9.7361 17.5813 10.2637 17.2558 10.5892L11.4225 16.4225C11.0971 16.7479 10.5694 16.7479 10.244 16.4225C9.91856 16.0971 9.91856 15.5694 10.244 15.244L15.4881 9.99992L10.244 4.75584C9.91856 4.4304 9.91856 3.90277 10.244 3.57733Z"
    />
  </svg>
);

const DoubleRightIcon = (props) => <Icon component={SVG} {...props} />;

export default DoubleRightIcon;
